import {forwardRef, SVGAttributes} from 'react';

export const CrossIcon = forwardRef<SVGSVGElement, SVGAttributes<SVGSVGElement>>((props, ref) => {
	const color = props.color ? props.color : '#000000';
	return <svg width='24' height='24' viewBox='0 0 48 48' {...props} ref={ref}>
		<g fill='none' fillRule='evenodd'>
			<rect width='48' height='48'/>
			<path stroke={color} strokeWidth='4' d='M13,13 L35,35' strokeLinecap='round'
			      transform='matrix(-1 0 0 1 48 0)'/>
			<path stroke={color} strokeWidth='4' d='M13,13 L35,35' strokeLinecap='round'/>
		</g>
	</svg>;
});
